// 系统配置
import { doGet, doPost } from '@/api/http'
let apis = '/electricity'

// ------------------------- 系统配置 start ---------------------

/**
 * 编辑企业信息
 * @param {*} showName  巡检项名称
 * @param {*} logo  企业logo
 * @param {*} wmsAddress  wms地址
 * @param {*} gcLongitudeLatitude  国测局经纬度
 * @param {*} mapLevel  地图层级
 */
export async function editSystemDetail (params) {
  let result = await doPost(apis + '/metadata/config/edit', params)
  return result
}

/**
 * 获取系统详情
 * @param {*} id 企业id
 */
export async function getSystemDetail (params) {
  let result = await doGet(apis + '/metadata/config/getDetail', params, null, true)
  return result
}
